export const priceType = {
  regular: 'REGULAR',
  event: 'EVENT'
}
export const dayType = {
  weekdays: 'WEEKDAYS',
  weekend: 'WEEKEND',
  holiday: 'HOLIDAY'
}
export const priceSections = [
  priceType.regular,
  priceType.event
]
export const sectionValues = {
  REGULAR: {
    title: 'Set Regular Price',
    types: [
      dayType.weekdays,
      dayType.weekend,
      dayType.holiday
    ]
  },
  EVENT: {
    title: 'Set Event Price',
    types: [
      dayType.weekdays,
      dayType.weekend
    ]
  }
}
export const sectionDayWording = {
  WEEKDAYS: {
    title: 'Weekdays',
    days: 'Monday - Friday'
  },
  WEEKEND: {
    title: 'Weekend',
    days: 'Satuday - Sunday'
  },
  HOLIDAY: {
    title: 'Holiday',
    days: 'National holiday'
  }
}